import {
  Box,
  Input,
  SwipeableDrawer,
  MenuItem,
  Select as MuiSelect,
} from '@mui/material'
import React, { Fragment, useState } from 'react'
import 'dayjs/locale/vi'
import TextField from '@mui/material/TextField'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker'
import { ELECTRONIC_DOCUMENT_STATUS } from '../../constants'

const AdvancedFilter = props => {
  const {
    openAdvancedFilter,
    handleOpenAdvancedFilter,
    handleCloseAdvancedFilter,
    filter,
    setFilter,
    checkV2,
    setCheckV2,
  } = props

  const handleChangeKeyword = keyword => {
    setFilter({
      ...filter,
      title: keyword.target.value.trim(),
      value: keyword.target.value,
    })
  }

  const handleChangeFromDate = newValue => {
    setFilter({
      ...filter,
      from_date: newValue.format('YYYY-MM-DD'),
    })
  }

  const handleChangeToDate = newValue => {
    setFilter({
      ...filter,
      to_date: newValue.format('YYYY-MM-DD'),
    })
  }

  const handleStatusChange = event => {
    setFilter({
      ...filter,
      status: event.target.value || null,
    })
  }

  const handleApply = () => {
    setFilter({ ...filter, page: 0, size: 10 })
    handleCloseAdvancedFilter()
  }

  const handleReset = () => {
    setFilter({
      ...filter,
      title: '',
      from_incoming_date: null,
      to_incoming_date: null,
      status: '',
      value: '',
    })
    setCheckV2(!checkV2)
  }

  const list = (
    <>
      <Box
        sx={{
          width: '335px',
          pt: '50px',
          minHeight: '500px',
          '& ul': {
            position: 'unset',
            marginBottom: '70px',
          },
        }}
        role="presentation">
        <div className="px-5 mt-[50px]">
          <div className="min-h-[calc(100vh-90px)]">
            <p className="font-semibold text-sm leading-5 text-[#16192C] mb-2">
              Tìm kiếm
            </p>
            <Input
              className="h-[56px] w-full border border-blue-400 rounded-md px-2"
              placeholder=" Theo trích yếu / số hiệu / số đến"
              type="search"
              value={filter?.value}
              onChange={handleChangeKeyword}
              disableUnderline
            />
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Ngày trình
            </p>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
              <div className="flex gap-3">
                <div className="mt-2">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    value={filter?.from_date || null}
                    onChange={handleChangeFromDate}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                  />
                </div>
                <div style={{ marginTop: '22px' }}>-</div>
                <div className="mt-2">
                  <MobileDatePicker
                    inputFormat="DD/MM/YYYY"
                    value={filter?.to_date || null}
                    onChange={handleChangeToDate}
                    renderInput={params => (
                      <TextField
                        {...params}
                        error={false}
                        placeholder="DD/MM/YYYY"
                      />
                    )}
                  />
                </div>
              </div>
            </LocalizationProvider>

            {/* Status Select */}
            <p className="font-semibold text-sm leading-5 text-[#16192C] mt-6 mb-1">
              Trạng thái
            </p>
            <MuiSelect
              value={filter?.status || ''}
              onChange={handleStatusChange}
              displayEmpty
              fullWidth
              variant="outlined"
              placeholder="Chọn trạng thái">
              <MenuItem value="">
                <em>Chọn trạng thái</em>
              </MenuItem>
              <MenuItem value={ELECTRONIC_DOCUMENT_STATUS.PENDING}>
                Chưa xử lý
              </MenuItem>
              <MenuItem value={ELECTRONIC_DOCUMENT_STATUS.VT_APPROVAL}>
                Văn thư duyệt
              </MenuItem>
              <MenuItem value={ELECTRONIC_DOCUMENT_STATUS.LEAD_APPROVAL}>
                Lãnh đạo duyệt
              </MenuItem>
              <MenuItem value={ELECTRONIC_DOCUMENT_STATUS.REGIS_NUMBER}>
                Cấp số
              </MenuItem>
              <MenuItem value={ELECTRONIC_DOCUMENT_STATUS.RELEASE}>
                Phát hành
              </MenuItem>
            </MuiSelect>
          </div>
        </div>
      </Box>
      <div className="fixed flex bottom-0 w-[335px] bg-white h-20 p-4">
        <button
          onClick={handleReset}
          className="text-center border-[1px] border-primary rounded text-primary w-1/2 py-[12px] mr-[5px]">
          <div className="font-semibold text-[14px] leading-[22px] px">
            Nhập lại
          </div>
        </button>
        <button
          onClick={handleApply}
          className="text-center w-1/2 border-[1px] block text-white rounded bg-primary py-[12px] ml-[5px]">
          <div className="font-semibold text-[14px] leading-[22px] px">
            Áp dụng
          </div>
        </button>
      </div>
    </>
  )

  return (
    <Fragment>
      <SwipeableDrawer
        anchor={'right'}
        open={openAdvancedFilter}
        onOpen={handleOpenAdvancedFilter}
        onClose={handleCloseAdvancedFilter}
        disableSwipeToOpen={false}>
        {list}
      </SwipeableDrawer>
    </Fragment>
  )
}

export default AdvancedFilter
